import React from 'react';
import { CHECKOUT_URL } from '../data/oferta';
type CtaButtonProps = {
  children: React.ReactNode;
  className?: string;
};
export function CtaButton({
  children,
  className = ''
}: CtaButtonProps) {
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`group inline-flex w-full max-w-xl items-center justify-center rounded-xl bg-flame px-6 py-5 text-center text-lg font-extrabold uppercase tracking-tight text-white shadow-cta transition-[transform,box-shadow,background-color] duration-150 ease-expo hover:bg-flame-dark focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-flame/40 active:translate-y-1.5 active:shadow-cta-press sm:text-xl ${className}`} data-id="element-19" data-mp="hk5h5hwfv9qa">
      {children}
    </a>;
}